"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgFilter = function SvgFilter(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M13.236 15.646A1 1 0 0114 14h20a1 1 0 01.764 1.646L27 24.826V33a1 1 0 01-1.447.894l-4-2A1 1 0 0121 31v-6.174l-7.764-9.18zm9.528 8.168a1 1 0 01.236.646v5.922l2 1V24.46a1 1 0 01.236-.646L31.845 16h-15.69l6.609 7.814z",
    id: "filter_svg__a"
  }));
};

var _default = SvgFilter;
exports["default"] = _default;